import { render, staticRenderFns } from "./ConfirmCode.vue?vue&type=template&id=970936c8"
import script from "./ConfirmCode.vue?vue&type=script&lang=js"
export * from "./ConfirmCode.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCode.vue?vue&type=style&index=0&id=970936c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports